module.exports = __webpack_public_path__ + "static/media/mobileDataTile.21d7bb8b.svg";